/* consultation.js — <product-consultation>: keeps the WhatsApp link and the
   hidden context fields of the enquiry form in step with the chosen variant.

   Dawn's product-info.js only swaps a fixed set of ids on a variant change
   (price, sku, inventory, ...) and leaves custom blocks alone, so without this
   the prefilled WhatsApp text and the "Variante" field would still name the
   length the page was opened with after the customer clicks another one.

   The variantChange payload carries the freshly rendered section HTML for the
   new variant, which already contains this block rendered for that variant.
   We copy only the marked attributes/values across (never innerHTML), so
   anything the customer has typed into the form survives the switch.

   Loaded by sections/main-product.liquid only when the product is flagged.
   The quick view renders the compact mode without a form and without this
   script (scripts in a fetched body never execute) — its link reflects the
   variant the dialog opened on, which is what the picker there sets.
*/

(() => {
  if (customElements.get('product-consultation')) return;

  customElements.define(
    'product-consultation',
    class ProductConsultation extends HTMLElement {
      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          if (!data || data.sectionId !== this.dataset.section || !data.html) return;
          const fresh = data.html.getElementById(this.id);
          if (!fresh) return;

          fresh.querySelectorAll('[data-consultation-sync]').forEach((source) => {
            const key = source.dataset.consultationSync;
            const target = this.querySelector(`[data-consultation-sync="${key}"]`);
            if (!target) return;

            if (source.tagName === 'A') {
              target.href = source.href;
            } else if (source.tagName === 'INPUT') {
              target.value = source.value;
            } else {
              target.textContent = source.textContent;
            }
          });
        });
      }

      disconnectedCallback() {
        if (this.unsubscribeVariant) this.unsubscribeVariant();
      }
    }
  );
})();
